import {
	KNOWLEDGE_BASE_ITEM_REQUEST,
	KNOWLEDGE_BASE_ITEM_REQUEST_SUCCESS,
	KNOWLEDGE_BASE_ITEM_REQUEST_FAILURE,
	SET_BREADCRUMBS,
	KNOWLEDGE_BASE_RESET,
	KNOWLEDGE_BASE_REQUEST,
	KNOWLEDGE_BASE_REQUEST_SUCCESS,
	KNOWLEDGE_BASE_REQUEST_FAILURE,
	KNOWLEDGE_BASE_SEARCH_QUERY_UPDATE,
	KNOWLEDGE_BASE_SEARCH_MODE_ENABLE,
	KNOWLEDGE_BASE_SEARCH_MODE_DISABLE,
	KNOWLEDGE_BASE_ITEM_CLEAR,
} from 'constants/actions';

const initialBreadcrumbs = [{
	text: 'База знань',
	index: null,
	key: 'home',
}];

const createAppealState = () => ({
	requestedForAppeal: '',
	knowledgeBase: [],
	knowledgeBaseLoading: false,
	query: '',
	searchMode: false,
	selectedItem: null,
	selectedItemLoading: false,
	breadcrumbs: initialBreadcrumbs,
});

const initialState = {
	appeals: {},
};

const updateAppealState = (state, appealId, newState = {}) => {
	if (!appealId) {
		return state;
	}

	const currentAppealState = state.appeals[appealId] || createAppealState();

	return {
		...state,
		appeals: {
			...state.appeals,
			[appealId]: {
				...currentAppealState,
				...newState,
			},
		},
	};
};

export default (state = initialState, action) => {
	switch (action.type) {
	/********  Knowledge base request  ********/

	case KNOWLEDGE_BASE_REQUEST:
		return updateAppealState(state, action.appealId, {
			knowledgeBaseLoading: true,
			requestedForAppeal: action.appealId,
		});

	case KNOWLEDGE_BASE_REQUEST_SUCCESS:
		return updateAppealState(state, action.appealId, {
			knowledgeBase: action.knowledgeBase,
			knowledgeBaseLoading: false,
		});

	case KNOWLEDGE_BASE_REQUEST_FAILURE:
		return updateAppealState(state, action.appealId, {
			knowledgeBase: [],
			knowledgeBaseLoading: false,
		});

		/********  Knowledge base search query update  ********/

	case KNOWLEDGE_BASE_SEARCH_QUERY_UPDATE:
		return updateAppealState(state, action.appealId, {
			query: action.query,
		});

		/********  Knowledge base search mode update  ********/

	case KNOWLEDGE_BASE_SEARCH_MODE_ENABLE:
		return updateAppealState(state, action.appealId, {
			searchMode: true,
		});

	case KNOWLEDGE_BASE_SEARCH_MODE_DISABLE:
		return updateAppealState(state, action.appealId, {
			searchMode: false,
		});

		/********  Knowledge base breadcrumbs update  ********/

	case SET_BREADCRUMBS:
		return updateAppealState(state, action.appealId, {
			breadcrumbs: action.breadcrumbs,
		});

		/********  Knowledge base item request  ********/

	case KNOWLEDGE_BASE_ITEM_REQUEST:
		return updateAppealState(state, action.appealId, {
			selectedItemLoading: true,
		});

	case KNOWLEDGE_BASE_ITEM_REQUEST_SUCCESS:
		return updateAppealState(state, action.appealId, {
			selectedItem: action.selectedItem,
			selectedItemLoading: false,
		});

	case KNOWLEDGE_BASE_ITEM_REQUEST_FAILURE:
		return updateAppealState(state, action.appealId, {
			selectedItem: null,
			selectedItemLoading: false,
		});

	case KNOWLEDGE_BASE_ITEM_CLEAR:
		return updateAppealState(state, action.appealId, {
			selectedItem: null,
			selectedItemLoading: false,
		});

		/********  Knowledge base reset  ********/

	case KNOWLEDGE_BASE_RESET:
		if (!action.appealId) {
			return initialState;
		}

		return updateAppealState(state, action.appealId, createAppealState());

	default: return state;
	}
};
